import Image from './Image';

export { ICONS, LOGOS, GIFS } from './Image.constants';

export default Image;
